export type ManufacturerTechnicalLink = {
  label: string;
  href: string;
  description: string;
};

export type ManufacturerTechnicalResource = {
  brand: "Bobrick" | "ASI" | "Bradley";
  summary: string;
  links: ManufacturerTechnicalLink[];
};

/**
 * Official external manufacturer destinations checked on 2026-10-24.
 * Partition Stalls links to—not hosts, copies, or guarantees—the files on these sites.
 */
export const manufacturerTechnicalResources: ManufacturerTechnicalResource[] = [
  {
    brand: "Bobrick",
    summary: "Official paths for current BIM, CAD, technical-data, and advisory-bulletin research.",
    links: [
      {
        label: "BIM, CAD & technical data",
        href: "https://www.bobrick.com/resource-center-2/tools/bim-objects-cad-tds/",
        description: "BIM objects, CAD, technical data sheets, and partition-resource paths.",
      },
      {
        label: "Technical bulletins",
        href: "https://www.bobrick.com/resource-center-2/literature/technical-bulletins/",
        description: "Design, installation, and maintenance bulletins from Bobrick.",
      },
    ],
  },
  {
    brand: "ASI",
    summary: "Official paths for current model installation instructions, diagrams, and BIM content.",
    links: [
      {
        label: "Installation instructions & diagrams",
        href: "https://americanspecialties.com/installation-instructions-and-diagrams/",
        description: "Search ASI’s current model-number instructions and diagrams at the source.",
      },
      {
        label: "BIM content",
        href: "https://americanspecialties.com/bim-objects/",
        description: "ASI’s official BIM resource destination.",
      },
    ],
  },
  {
    brand: "Bradley",
    summary: "Official paths for current product resources, BIM/Revit files, and 3-part specifications.",
    links: [
      {
        label: "Product resources",
        href: "https://www.bradleycorp.com/resources",
        description: "Application guides, installation videos, parts, and product-resource paths.",
      },
      {
        label: "BIM / Revit",
        href: "https://www.bradleycorp.com/bim",
        description: "Bradley’s official data-rich Revit and CAD content library.",
      },
      {
        label: "3-part specifications",
        href: "https://www.bradleycorp.com/3-part-spec",
        description: "Bradley’s official specification-document resource.",
      },
    ],
  },
];

export function getManufacturerTechnicalResource(brand: string) {
  return manufacturerTechnicalResources.find((resource) => resource.brand === brand);
}
